import { Button, Form, Modal } from '@mairistem/composants';
import React from 'react';
import type {
	DemandeCompte,
	DemandeCompteEditableFields,
} from '../../interfaces/demandeCompte';

interface UpdateDemandeCompteModalProps {
	demandeCompte: DemandeCompte;
	onClose: () => void;
	onValidate: (updatedFields: DemandeCompteEditableFields) => void;
	isLoading: boolean;
}

const UpdateDemandeCompteModal = ({
	demandeCompte,
	onClose,
	onValidate,
	isLoading,
}: UpdateDemandeCompteModalProps) => {
	const [formData, setFormData] = React.useState<DemandeCompteEditableFields>({
		codeClient: demandeCompte.codeClient ?? '',
		siren: demandeCompte.siren ?? '',
		email: demandeCompte.email ?? '',
		qualite: demandeCompte.qualite ?? '',
		nom: demandeCompte.nom ?? '',
		prenom: demandeCompte.prenom ?? '',
		codePostal: demandeCompte.codePostal ?? '',
		ville: demandeCompte.ville ?? '',
		fonction: demandeCompte.fonction ?? '',
	});
	const [isConfirmed, setIsConfirmed] = React.useState<boolean>(false);

	const handleChange = (
		_e: React.SyntheticEvent<HTMLElement>,
		{ name, value }: { name: string; value: string },
	) => {
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	return (
		<Modal onClose={onClose} size="small" open>
			<Modal.Header>Modification de la demande de compte</Modal.Header>
			<Modal.Content>
				<Form>
					<Form.Group widths="equal">
						<Form.Input
							label="Code client"
							name="codeClient"
							value={formData.codeClient}
							onChange={handleChange}
						/>
						<Form.Input
							label="SIREN"
							name="siren"
							value={formData.siren}
							onChange={handleChange}
						/>
					</Form.Group>
					<Form.Input
						label="Email"
						name="email"
						value={formData.email}
						onChange={handleChange}
						type="email"
					/>
					<Form.Group widths="equal">
						<Form.Input
							label="Qualité"
							name="qualite"
							value={formData.qualite}
							onChange={handleChange}
						/>
						<Form.Input
							label="Fonction"
							name="fonction"
							value={formData.fonction}
							onChange={handleChange}
						/>
					</Form.Group>
					<Form.Group widths="equal">
						<Form.Input
							label="Nom"
							name="nom"
							value={formData.nom}
							onChange={handleChange}
						/>
						<Form.Input
							label="Prénom"
							name="prenom"
							value={formData.prenom}
							onChange={handleChange}
						/>
					</Form.Group>
					<Form.Group widths="equal">
						<Form.Input
							label="Code postal"
							name="codePostal"
							value={formData.codePostal}
							onChange={handleChange}
						/>
						<Form.Input
							label="Ville"
							name="ville"
							value={formData.ville}
							onChange={handleChange}
						/>
					</Form.Group>
					<Form.Checkbox
						label="Je confirme avoir vérifié les informations"
						checked={isConfirmed}
						onChange={() => setIsConfirmed((prev) => !prev)}
					/>
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button color="black" onClick={onClose}>
					Annuler
				</Button>
				<Button
					icon="checkmark"
					onClick={() => onValidate(formData)}
					primary
					loading={isLoading}
					disabled={!isConfirmed}
				>
					Modifier la demande
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default UpdateDemandeCompteModal;
